import React from "react";
import MediaWithText from "components/media-with-text";
import { Navigation, Mousewheel, Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "components/swiper";
import MediaQuery from "components/media-query";
import { SCREEN_SIZES } from "utils/constants";
import clsx from "clsx/lite";

const MediaWithTextGroup = ({ data, className }) => {
	const { slideOnMobile } = data || {};

	const swiperSettings = {
		modules: [Navigation, Mousewheel, Autoplay],
		speed: 2000,
		spaceBetween: 20,
		mousewheel: { enabled: true, forceToAxis: true },
		breakpoints: {
			320: { slidesPerView: 1.1 },
			680: { slidesPerView: 2.1 },
			992: { slidesPerView: 3 },
		},
	};

	return (
		<div className={clsx(className, "flex items-center flex-col gap-6 md:gap-10")}>
			{data.title &&
				<h2 className={clsx("w-full text-left md:text-center leading-normal md:py-3.5",
					slideOnMobile && "sm:text-center text-left")}>
					{data.title}
				</h2>}
			{slideOnMobile ?
				<>
					<MediaQuery maxWidth={SCREEN_SIZES.sm}>
						<Swiper {...swiperSettings} className="w-full">
							<div className="grid grid-cols-1 gap-0">
								{data.items?.map((item, index) => (
									<SwiperSlide key={index} className="relative h-auto media-with-text-slider flex flex-col">
										<div className="content-fit relative h-full">
											<MediaWithText data={item} />
										</div>
									</SwiperSlide>
								))}
							</div>
						</Swiper>
					</MediaQuery>
					<MediaQuery minWidth={SCREEN_SIZES.sm}>
						<div className="flex items-center flex-col gap-10">
							{data.items?.map((item, index) => (
								<MediaWithText key={index} data={item} />
							))}
						</div>
					</MediaQuery>
				</>
				:
				<div className="flex items-center flex-col gap-10">
					{data.items?.map((item, index) => (
						<MediaWithText key={index} data={item} />
					))}
				</div>
			}
		</div>
	);
};

export default MediaWithTextGroup;
